export default __webpack_public_path__ + "static/media/detail_mobile_15_4.215903fe.jpg";